import { Fragment, useEffect, useRef, useState } from "react";
import './Schedule.scss'
import {
    CollapseSvg,
    GroundTaskSvg,
    OnBoardSvg,
    PayloadTaskSvg,
    PinSvg,
    TaskUpcommingSvg,
} from "../Svgs";
import Modal from "../Modal";
import useModals from "../../../../hooks/useModals";
import useOnBoardSchedule, { ScheduleTask } from "../../../../hooks/useOnBoardSchedule";
import CustomLoader from "../../../../custom_components/CustomLoader";
import CustomToolTip from "../../../../../CommonComponents/CustomToolTip";
import useContacts from "../../../../hooks/useContacts";
import useViewer from "../../../../hooks/useViewer";
import { get_formated_time, get_task_status_icon } from "../../../../utils";
import useUrlParams from "../../../../hooks/useUrlParams";
import { Modals } from "../../../../providers/ModalProvider";

const OnBoardschedule = () => {
    const { dashboard } = useUrlParams()
    const { selectedScheduleTask } = useContacts()
    const { current_simulation_time } = useViewer()
    const { loading, scheduleData, select_schedule_data } = useOnBoardSchedule()
    const [expand, setExpand] = useState(false);
    const { open_modal, close_modal, pinned_modal, get_modal_details } = useModals()
    const modal: Modals = get_modal_details('onboard_schedule')

    const taskRef = useRef<any>(null);
    const containerRef = useRef<any>(null);

    useEffect(() => {
        const close_open_modal = () => {
            if (!modal.open) return
            else if (modal.open && modal.pinned) return
            else {
                close_modal('onboard_schedule')
            }
        }
        window.addEventListener('click', close_open_modal)
        return () => {
            window.removeEventListener('click', close_open_modal)
        }
    }, [])

    useEffect(() => {
        if (!selectedScheduleTask.default_schedule) {
            const element = taskRef.current;
            const container = containerRef.current;

            if (element && container) {
                const { top: elementTop, bottom: elementBottom } = element.getBoundingClientRect();
                const { top: containerTop, bottom: containerBottom } = container.getBoundingClientRect();

                if (elementTop < containerTop || elementBottom > containerBottom) {
                    const scrollTop = element.offsetTop - container.offsetTop;
                    container.scrollTop = scrollTop
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        }
        // Scroll the last task into view when the component mounts or tasks change

    }, [selectedScheduleTask]);


    return (
        <Modal
            open={modal.open}
            pinned={modal.current_modal === 'onboard_schedule' && modal.pinned}
            disabled={modal.current_modal === 'onboard_schedule' && modal.pinned}
            class_name={`${modal.current_modal === 'onboard_schedule' ? 'current__modal' : ''}`}
        >
            <div className={`schedule__panel__container ${expand && 'expand'} `}
                onClick={(event: any) => {
                    event.stopPropagation()
                    open_modal('onboard_schedule')

                }}>
                <div className="schedule__panel__header">
                    <div className=" d-flex align-items-center gap-2">
                        <OnBoardSvg />
                        <span className="panel__header__title">Onboard Schedule</span>
                    </div>
                    <div className=" d-flex align-items-center">
                        <button className="panel__colapse__btn" onClick={(event: any) => {
                            event.stopPropagation()
                            setExpand(!expand)
                        }}>
                            <CollapseSvg />
                        </button>
                        <button className={`panel__pin__btn ${modal.pinned ? 'pinned' : ''}`}
                            onClick={(event: any) => {
                                event.stopPropagation()
                                pinned_modal('onboard_schedule')
                            }}>
                            <PinSvg />
                        </button>
                        <button className={`panel__close__btn`}
                            onClick={(event: any) => {
                                event.stopPropagation()
                                close_modal('onboard_schedule')

                            }}>
                            <i className="fe fe-x fs-16" />
                        </button>
                    </div>
                </div>
                <div className="schedule__panel__body__container">
                    <CustomLoader loading={loading} />
                    {(!loading && scheduleData?.length > 0) &&
                        <Fragment>
                            <div className="panel__container__header">
                                <span className="container__header__item">Task</span>
                                <span className="container__header__item">Start Time</span>
                                <span className="container__header__item">Geo-trigger | Location</span>
                            </div>
                            <div className="panel__container__body" ref={containerRef}>
                                {scheduleData && scheduleData?.map((task: ScheduleTask, index) => {
                                    const current_time = current_simulation_time / 1000
                                    const task_start_time = task.startTime;
                                    const task_end_time = task.endTime;
                                    const task_type_icon = task.type === 'Payload Task' ? <PayloadTaskSvg /> : <GroundTaskSvg />
                                    const task_status_icon = dashboard !== 'operate' ? get_task_status_icon(task_start_time, task_end_time, current_time) : <TaskUpcommingSvg />
                                    const sub_name = task.type === 'Payload Task' ? `${task?.['properties']?.['payloadName']} | ${task?.['properties']?.['sequenceName']}` : `${task?.['properties']?.['groundStationName']}`
                                    // const task_running = task?.['status'] === 'active' ? 'running' : ''
                                    const task_running = (dashboard !== 'operate' && current_time >= task_start_time && current_time <= task_end_time) ? 'running' : ''
                                    const geo_trigger_location = task?.['location'] ? `${task?.['geoTrigger']} | ${task?.['location']}` : `${task?.['geoTrigger']}`

                                    return (
                                        <Fragment key={index}>
                                            <div
                                                ref={task?.['startTime'] === selectedScheduleTask?.schedule_data?.['startTime'] ? taskRef : null}
                                                className={`body__item__container ${!expand && 'cursor-auto'} ${(task?.['startTime'] === selectedScheduleTask?.schedule_data?.['startTime'] && expand) && 'active'}`}
                                                onClick={() => { select_schedule_data(task) }}
                                            >
                                                <div className={`item__details__header__container ${task_running}`}>
                                                    <div className="container__header__item">
                                                        <div className="icon__container">
                                                            {task_status_icon}
                                                            {task_type_icon}
                                                        </div>
                                                        <div className="details__container">
                                                            <span>
                                                                <CustomToolTip title={task?.['taskName']} placement="top">
                                                                    {task?.['taskName']}
                                                                </CustomToolTip>
                                                            </span>
                                                            <span>
                                                                <CustomToolTip title={sub_name} placement="top">
                                                                    {sub_name}
                                                                </CustomToolTip>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="container__header__item">
                                                        <span>{get_formated_time(task?.['startTime'])}</span>
                                                    </div>
                                                    <div className="container__header__item">
                                                        <span>
                                                            <CustomToolTip title={geo_trigger_location} placement="top">
                                                                {geo_trigger_location}
                                                            </CustomToolTip>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="item__details__body__container">
                                                    <div className="details__body__container__header">
                                                        <div className="details__body__container__header__item">SUBSYSTEM & COMMAND </div>
                                                        <div className="details__body__container__header__item">Start Time</div>
                                                        <div className="details__body__container__header__item">Duration</div>
                                                    </div>
                                                    <div className="details__body__container__body__container">
                                                        {task?.['commandsList'] && task?.['commandsList'].map((command, id) => {
                                                            const current_time = current_simulation_time / 1000
                                                            const sub_task_start_time = command.epoch;
                                                            const sub_task_end_time = command.epoch + command.duration;
                                                            const sub_task_status_icon = dashboard !== 'operate' ? get_task_status_icon(sub_task_start_time, sub_task_end_time, current_time) : <TaskUpcommingSvg />;
                                                            // const sub_task_running = command?.['status'] === 'active' ? 'running' : ''
                                                            const sub_task_running = (dashboard !== 'operate' && current_time >= sub_task_start_time && current_time <= sub_task_end_time) ? 'running' : ''
                                                            return (
                                                                <Fragment key={id}>
                                                                    <div className={`details__body__container__body ${sub_task_running}`}>
                                                                        <div className="details__body__container__body__item">
                                                                            <div className="icon__container">{sub_task_status_icon}</div>
                                                                            <div className="details__container">
                                                                                <span>
                                                                                    <CustomToolTip title={command?.['name']} placement="top">
                                                                                        {command?.['name']}
                                                                                    </CustomToolTip>
                                                                                </span>
                                                                                <span>
                                                                                    <CustomToolTip title={command?.['subsystem']} placement="top">
                                                                                        {command?.['subsystem']}
                                                                                    </CustomToolTip>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="details__body__container__body__item">
                                                                            <span>{get_formated_time(command?.['epoch'])}</span>
                                                                        </div>
                                                                        <div className="details__body__container__body__item">
                                                                            <span>{command?.['duration']} sec</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="details__body__container__body__container__separator" />
                                                                </Fragment>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="body__item__separator" />
                                        </Fragment>
                                    )
                                })}
                            </div>
                        </Fragment>
                    }
                </div>
            </div>
        </Modal>
    )
}

export default OnBoardschedule